import { useState } from "react";
import { Link } from "react-router-dom";
import { IFRSListItemDTO } from "../../../api/Quiz/GetAllIFRS";
import { Edit, FileText, Users } from "lucide-react";
import TrashIcon from "../../Icons/TrashIcon";
import DeleteModal from "../../Shared/DeleteModal";
import { DeleteIFRS } from "../../../api/Quiz/DeleteIFRS";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";

interface IFRSExamRowProps {
  exam: IFRSListItemDTO;
}

const IFRSExamRow = ({ exam }: IFRSExamRowProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const queryClient = useQueryClient();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = date.getHours() >= 12 ? "PM" : "AM";

    return `${day}.${month}.${year} - ${hours}:${minutes} ${ampm}`;
  };

  const handleDelete = async (id: string) => {
    const result = await DeleteIFRS(id);
    if (!result.error) {
      toast.success("IFRS Exam deleted successfully");
      queryClient.invalidateQueries({ queryKey: ["ifrs-exams"] });
    } else {
      toast.error("Failed to delete IFRS Exam");
    }
  };

  return (
    <>
      <tr>
        <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
          <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
            {exam.id}
          </div>
        </td>
        <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
          <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
            {exam.title}
          </div>
        </td>
        <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
          <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
            {exam.duration} min
          </div>
        </td>
        <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
          <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
            {formatDate(exam.createdAt)}
          </div>
        </td>
        <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
          <div className="flex justify-center items-stretch gap-3">
            <div className="flex flex-shrink-0 rounded-xl justify-center items-center border p-3 text-sm font-semibold cursor-pointer hover:bg-gray-50">
              <Link to={`${exam.id}/questions`}>
                <FileText size={18} />
              </Link>
            </div>
            <div className="flex flex-shrink-0 rounded-xl justify-center items-center border p-3 text-sm font-semibold cursor-pointer hover:bg-gray-50">
              <Link to={`${exam.id}/students`} title="Students">
                <Users size={18} />
              </Link>
            </div>
            <div className="flex flex-shrink-0 rounded-xl justify-center items-center border p-3 text-sm font-semibold cursor-pointer hover:bg-gray-50">
              <Link to={`edit/${exam.id}`}>
                <Edit size={18} />
              </Link>
            </div>
            <div className="flex flex-shrink-0 rounded-xl justify-center items-center border p-3 text-sm font-semibold cursor-pointer hover:bg-gray-50">
              <button onClick={() => setIsOpen(true)}>
                <TrashIcon />
              </button>
            </div>
          </div>
        </td>
      </tr>
      <DeleteModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        mutationFn={handleDelete}
        itemId={exam.id}
        queryKey="ifrs-exams"
      />
    </>
  );
};

export default IFRSExamRow;
